import { createSlice } from "@reduxjs/toolkit";

export const dataSlice = createSlice({
  name: "data",
  initialState: {
    academiaData: {},
    academiaHeaderUrl: "",
    academiaSearch: "Academia",
    academiaSearchList: [],
    acceptedMISTerms: false,
    articleDataCitation: {},
    articleSummary: "",
    avatarProps: null,
    boclipsPopup: false,
    boClipsVideoId: null,
    bookmarkArticle: false,
    bookmarkCategory: null,
    bookmarkData: {},
    bookmarkedData: { isCitationAvailable: false, id: null },
    bookmarkUrls: [],
    categories: {},
    citationData: "",
    risCitationData: "",
    collectionId: null,
    collectionIdArray: [],
    collections: [],
    archivedCollections: [],
    collectionSourceId: null,
    bookmarkedCollectionIds: [],
    collectionsSidebar: true,
    datePicker: false,
    entityName: "",
    eventName: null,
    fromDate: null,
    hiddenNews: [],
    isBookmarkSidebar: false,
    isCategoriesSelected: false,
    isCitationAvailable: false,
    isExpanded: false,
    isReadingAvailable: false,
    // True while viewing someone else's collection through a submission, where every
    // collection surface behaves like an archived collection: visible but not editable.
    isReadOnlyView: false,
    isSidebarOpen: false,
    isSourceSidebarOpen: false,
    isSummaryAvailable: false,
    itemTypes: {},
    level: "",
    newsData: null,
    note: {},
    otherLabelsNeeded: true,
    parentCollections: [],
    profilePicNav: true,
    profilePicUrl: "",
    pulseCategoryId: null,
    pulseMenuSidebar: true,
    readingLevelText: "",
    readingSummary: "",
    search: "",
    searchFilter: { name: "All time", value: "" },
    selectedBookmarkOption: "notes",
    showAddToCollectionsField: false,
    sidebarDataCopy: null,
    sourceUrl: null,
    selectedCollection: {},
    showCharity: true,
    showTitleRedirect: { popup: true, title: "" },
    subPopup: false,
    summary: "",
    summaryInfoData: {
      publisher: "",
      title: "",
      published_date: "",
      url: "",
      utc_date_published: "",
    },
    toDate: null,
    toolsSidebar: true,
    url: "",
    feedCategoriesData: [],
    breakCategoriesData: [],
    noFetchMore: {},
  },
  reducers: {
    setBoclipsPopup: (state, action) => {
      const { payload } = action;

      state.boclipsPopup = payload;
    },
    setBoclipsVideoId: (state, action) => {
      const { payload } = action;

      state.boClipsVideoId = payload;
    },
    setSubPopup: (state, action) => {
      const { payload } = action;

      state.subPopup = payload;
    },
    setOthersNeeded: (state, action) => {
      const { payload } = action;

      state.otherLabelsNeeded = payload;
    },
    setLevel: (state, action) => {
      const { payload } = action;

      state.level = payload;
    },
    setReadingLevelText: (state, action) => {
      const { payload } = action;

      state.readingLevelText = payload;
    },
    setSummary: (state, action) => {
      const { payload } = action;

      state.summary = payload;
    },
    setReadingSummary: (state, action) => {
      const { payload } = action;
      state.readingSummary = payload;
    },
    setReadingLevelAvailable: (state, action) => {
      const { payload } = action;

      state.isReadingAvailable = payload;
    },
    setCategories: (state, action) => {
      const { payload } = action;

      state.categories = payload;
    },
    setIsCategoriesSelected: (state, action) => {
      const { payload } = action;

      state.isCategoriesSelected = payload;
    },
    setAcceptedMISTerms: (state, action) => {
      const { payload } = action;

      state.acceptedMISTerms = payload;
    },
    setIsBookmarkSidebar: (state, action) => {
      const { payload } = action;

      state.isBookmarkSidebar = payload;
    },
    setIsReadOnlyView: (state, action) => {
      const { payload } = action;

      state.isReadOnlyView = payload;
    },
    setSourceUrl: (state, action) => {
      const { payload } = action;

      state.sourceUrl = payload;
    },
    setIsSourceSidebarOpen: (state, action) => {
      const { payload } = action;

      state.isSourceSidebarOpen = payload;
    },
    setEntityName: (state, action) => {
      const { payload } = action;

      state.entityName = payload;
    },
    setIsSidebarOpen: (state, action) => {
      const { payload } = action;

      state.isSidebarOpen = payload;
    },
    setnewsData: (state, action) => {
      const { payload } = action;

      state.newsData = payload;
    },
    sethiddenNews: (state, action) => {
      const { payload } = action;

      state.hiddenNews = payload;
    },
    setsearch: (state, action) => {
      const { payload } = action;

      state.search = payload;
    },
    setsearchFilter: (state, action) => {
      const { payload } = action;

      state.searchFilter = payload;
    },
    setBookmarkUrls: (state, action) => {
      const { payload } = action;

      state.bookmarkUrls = payload;
    },
    setBookmarkData: (state, action) => {
      const { payload } = action;

      state.bookmarkData = payload;
    },

    setCollections: (state, action) => {
      const { payload } = action;

      state.collections = payload;
    },
    setArchivedCollections: (state, action) => {
      const { payload } = action;

      state.archivedCollections = payload;
    },
    setSelectedCollection: (state, action) => {
      const { payload } = action;

      state.collections = payload;
    },
    setEventName: (state, action) => {
      const { payload } = action;

      state.eventName = payload;
    },
    setDatePicker: (state, action) => {
      const { payload } = action;

      state.datePicker = payload;
    },
    setFromDate: (state, action) => {
      const { payload } = action;
      state.fromDate = payload;
    },
    setToDate: (state, action) => {
      const { payload } = action;
      state.toDate = payload;
    },
    setShowCharity: (state, action) => {
      const { payload } = action;
      state.showCharity = payload;
    },

    setUrl: (state, action) => {
      const { payload } = action;
      state.url = payload;
    },
    setShowTitleRedirectPopup: (state, action) => {
      const { payload } = action;
      state.showTitleRedirect = payload;
    },
    setSummaryInfoData: (state, action) => {
      const { payload } = action;
      state.summaryInfoData = payload;
    },
    setArticleSummary: (state, action) => {
      const { payload } = action;
      state.articleSummary = payload;
    },

    setBookmarkArticle: (state, action) => {
      const { payload } = action;
      state.bookmarkArticle = payload;
    },
    setArticleDataCitation: (state, action) => {
      const { payload } = action;
      state.articleDataCitation = payload;
    },
    setCitationData: (state, action) => {
      const { payload } = action;
      state.citationData = payload;
    },
    setRisCitationData: (state, action) => {
      const { payload } = action;
      state.risCitationData = payload;
    },

    setProfilePicNav: (state, action) => {
      const { payload } = action;
      state.profilePicNav = payload;
    },
    setAcademiaSearch: (state, action) => {
      const { payload } = action;
      state.academiaSearch = payload;
    },
    setAcademiaSearchList: (state, action) => {
      const { payload } = action;
      state.academiaSearchList = payload;
    },
    setAcademiaData: (state, action) => {
      const { payload } = action;
      state.academiaData = payload;
    },
    setBookmarkCategory: (state, action) => {
      const { payload } = action;
      state.bookmarkCategory = payload;
    },
    setAcademiaHeaderUrl: (state, action) => {
      const { payload } = action;
      state.academiaHeaderUrl = payload;
    },
    setsidebarDataCopy: (state, action) => {
      const { payload } = action;

      state.sidebarDataCopy = payload;
    },
    setProfilePicUrl: (state, action) => {
      const { payload } = action;

      state.profilePicUrl = payload;
    },
    setIsExpanded: (state, action) => {
      const { payload } = action;

      state.isExpanded = payload;
    },
    setItemsPage: (state, action) => {
      const { payload } = action;

      state.itemTypes = payload;
    },
    setCollectionSourceId: (state, action) => {
      const { payload } = action;
      state.collectionSourceId = payload;
    },
    setCollectionId: (state, action) => {
      const { payload } = action;
      state.collectionId = payload;
    },
    setIsCitationAvailable: (state, action) => {
      const { payload } = action;
      state.isCitationAvailable = payload;
    },
    setIsSummaryAvailable: (state, action) => {
      const { payload } = action;
      state.isSummaryAvailable = payload;
    },
    setBookmarkedData: (state, action) => {
      const { payload } = action;
      state.bookmarkedData = payload;
    },
    setBookmarkedCollectionIds: (state, action) => {
      const { payload } = action;
      state.bookmarkedCollectionIds = Array.isArray(payload) ? payload : [];
    },
    setParentCollections: (state, action) => {
      const { payload } = action;
      state.parentCollections = payload;
    },
    setCollectionsSidebar: (state, action) => {
      const { payload } = action;
      state.collectionsSidebar = payload;
    },
    setToolsSidebar: (state, action) => {
      const { payload } = action;
      state.toolsSidebar = payload;
    },
    setNote: (state, action) => {
      const { payload } = action;
      state.note = payload;
    },
    setSelectedBookmarkOption: (state, action) => {
      const { payload } = action;
      state.selectedBookmarkOption = payload;
    },
    setPulseMenuSidebar: (state, action) => {
      const { payload } = action;
      state.pulseMenuSidebar = payload;
    },
    setPulseCategoryId: (state, action) => {
      const { payload } = action;
      state.pulseCategoryId = payload;
    },
    setShowAddToCollectionsField: (state, action) => {
      const { payload } = action;
      state.showAddToCollectionsField = payload;
    },
    setAvatarProps: (state, action) => {
      const { payload } = action;
      state.avatarProps = payload;
    },
    setCollectionIdArray: (state, action) => {
      const { payload } = action;
      state.collectionIdArray = Array.isArray(payload) ? payload : [];
    },
    setFeedCategoriesData: (state, action) => {
      state.feedCategoriesData = action.payload;
    },
    setBreakCategoriesData: (state, action) => {
      state.breakCategoriesData = action.payload;
    },
    setNoFetchMore: (state, action) => {
      const { category, value } = action.payload;
      state.noFetchMore = { ...state.noFetchMore, [category]: value };
    },
    resetNoFetchMore: (state) => {
      state.noFetchMore = {};
    },
  },
});

// this is for dispatch
export const {
  setBoclipsPopup,
  setBoclipsVideoId,
  setSubPopup,
  setOthersNeeded,
  setLevel,
  setReadingLevelText,
  setSummary,
  setReadingSummary,
  setReadingLevelAvailable,
  setCategories,
  setIsCategoriesSelected,
  setAcceptedMISTerms,
  setIsBookmarkSidebar,
  setIsReadOnlyView,
  setSourceUrl,
  setIsSourceSidebarOpen,
  // setsidebarData,
  setEntityName,
  setIsSidebarOpen,
  setnewsData,
  sethiddenNews,
  setsearch,
  setsearchFilter,
  setBookmarkUrls,
  setBookmarkData,
  setCollections,
  setArchivedCollections,
  setSelectedCollection,
  setEventName,
  setDatePicker,
  setToDate,
  setFromDate,
  setShowCharity,
  setUrl,
  setShowTitleRedirectPopup,
  setSummaryInfoData,
  setArticleSummary,

  setBookmarkArticle,
  setArticleDataCitation,
  setCitationData,
  setRisCitationData,
  setProfilePicNav,
  setAcademiaSearch,
  setAcademiaSearchList,
  setAcademiaData,
  setBookmarkCategory,
  setAcademiaHeaderUrl,
  setsidebarDataCopy,
  setProfilePicUrl,
  setIsExpanded,
  setItemsPage,
  setCollectionSourceId,
  setCollectionId,
  setIsCitationAvailable,
  setIsSummaryAvailable,
  setBookmarkedData,
  setBookmarkedCollectionIds,
  setParentCollections,
  setCollectionsSidebar,
  setToolsSidebar,
  setNote,
  setSelectedBookmarkOption,
  setPulseMenuSidebar,
  setPulseCategoryId,
  setShowAddToCollectionsField,
  setAvatarProps,
  setCollectionIdArray,
  setFeedCategoriesData,
  setBreakCategoriesData,
  setNoFetchMore,
  resetNoFetchMore,
} = dataSlice.actions;

// this is for configureStore
export default dataSlice.reducer;
